// extracted by mini-css-extract-plugin
var _1 = "CalendarGridDayPopoverRowSubItems-moduleCalendarGridDayPopoverRowSubItems__U4B25";
var _2 = "CalendarGridDayPopoverRowSubItems-modulelabel__QoELt";
var _3 = "CalendarGridDayPopoverRowSubItems-modulestatus__sH5Pw";
var _4 = "CalendarGridDayPopoverRowSubItems-modulesubItem__CPKRX";
export { _1 as "CalendarGridDayPopoverRowSubItems", _2 as "label", _3 as "status", _4 as "subItem" }
